import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,
    padding: 1,
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: 1,
  },
}));
const FibreCardComponent = ({ fieldName, value }) => {
  const valueData = value?.filter((x) => x.isSave);
  return (
    <TableContainer component={Paper}>
      <b>
        <u>{fieldName}</u>
      </b>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>Garment Component/ Fibre</StyledTableCell>
            <StyledTableCell>Total %</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {valueData?.map((garment, garmentIndex) => (
            <React.Fragment key={garmentIndex}>
              {garment.garment.map((garment2, garment2Index) => (
                <TableRow key={`garment-${garmentIndex}-${garment2Index}`}>
                  <StyledTableCell>{garment2.garment}</StyledTableCell>
                  <StyledTableCell>{garment.percentage}</StyledTableCell>
                </TableRow>
              ))}
              {garment.fibres.map((fibre, fibreIndex) => (
                <TableRow key={`fibre-${garmentIndex}-${fibreIndex}`}>
                  <StyledTableCell>{fibre.fibre}</StyledTableCell>
                  <StyledTableCell>
                    {fibre.percentage > 0 ? fibre.percentage : ""}
                  </StyledTableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FibreCardComponent;
